import MuiCssBaseline from "@mui/material/CssBaseline";
import PropTypes from "prop-types";

/**
 * CssBaseline component wrapper for Material-UI CssBaseline.
 * Wraps Material-UI CssBaseline with theme integration.
 * 
 * @component
 * @example
 * <CssBaseline />
 */
const CssBaseline = (props) => {
  return <MuiCssBaseline {...props} />;
};

CssBaseline.propTypes = {
  /**
   * You can use a custom element type for this component.
   */
  children: PropTypes.node,
  /**
   * Enable color-scheme CSS property to use `theme.palette.mode`.
   */
  enableColorScheme: PropTypes.bool,
};

export default CssBaseline;
